import Box from '@mui/material/Box'
import { makeStyles } from 'tss-react/mui'

import AppConfig from '../../config/AppConfig'

const useStyles = makeStyles()(() => ({
  wrapper: {
    width: '220px',
    height: '147px',
    display: 'flex',
    justifyContent: 'center',
  },
  imgContainer: {
    width: '140px',
    height: '140px',
    overflow: 'hidden',
    objectFit: 'cover',
    verticalAlign: 'middle',
  },
  img: {
    width: '100%',
  },
}))

const randomTransform = () => {
  let randomNumber = (limit) => Math.floor(Math.random() * (2 * limit)) - limit
  const rotation = randomNumber(20)
  const position = randomNumber(15)
  return `translateX(${position}%) rotate(${rotation}deg)`
}

const CarouselPreview = ({ shareSetting }) => {
  const cloudinaryName = AppConfig.CLOUD_NAME
  const { classes } = useStyles()
  const { digital_assets } = shareSetting
  const previewImages = digital_assets.slice(0, 3)

  return (
    <div className={classes.wrapper}>
      <div style={{ position: 'relative', width: '147px' }}>
        {previewImages.map((asset, index) => {
          const cloudinaryId = asset.file.public_id
          const imageUrl = `https://res.cloudinary.com/${cloudinaryName}/image/upload/c_crop,w_400,h_400,g_face/w_200/${cloudinaryId}`
          return (
            <Box
              boxShadow={5}
              className={classes.imgContainer}
              left="0px"
              position="absolute"
              style={{
                transform: index === 0 ? null : randomTransform(),
              }}
              zIndex={0 - index}
            >
              <img
                alt={asset.file.name}
                className={classes.img}
                src={imageUrl}
              />
            </Box>
          )
        })}
      </div>
    </div>
  )
}

export default CarouselPreview
